import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseField from "./_imports/forms-base-field.vue";

export default {
	name: 'forms-message-field',
	template: getVueTemplate('forms-message-field'),
	mixins: [
		FormsBaseField
	],
	methods: {
		onCreated() {
			this.ignore = true;
			this.isValid = true;
		}
	}
};